import React, { Component } from 'react';
import './index.css';


class TickerScale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numType:'percent'
    }
    this.handleMouseHover = this.handleMouseHover.bind(this);
  }

  handleMouseHover(e){
    const { ticker } = this.props;
    this.props.onMouseHover(e, ticker)
  }

  render() {
    const { ticker } = this.props;
    const { w,h } = ticker.position;
    let base = Math.min(w, h)
    let baseSize = Math.round(base / 5.6);
    return (
      <div id='sc-market-map-ticker-scale-container' style={{display:baseSize < 7 ? 'none': '', fontSize: baseSize + 'px'}}>
        { isNaN(ticker.color) ? 'N/A' : ticker.color.toFixed(1) + '%' }
      </div>
    );
  }
}



export default TickerScale;




